import { render, staticRenderFns } from "./AddUrl.vue?vue&type=template&id=97feab1e&scoped=true&"
import script from "./AddUrl.vue?vue&type=script&lang=ts&"
export * from "./AddUrl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97feab1e",
  null
  
)

export default component.exports